import AuthService from "./auth.service";

import axios from "axios";
const Axios = axios.create();
import { store } from "../store/index";

// Function to check token expiry
export const isTokenExpires = (token) => {
  let flag = true;
  if (!!token) {
    const jwtPayload = JSON.parse(window.atob(token.split(".")[1]));
    const expiryTime = new Date(jwtPayload.exp * 1000);
    const currentTime = new Date();

    if (currentTime.getTime() < expiryTime.getTime()) {
      flag = false;
    }
  }
  return flag;
};

// Request interceptor for API calls
Axios.interceptors.request.use(
  async (config) => {
    const token = JSON.parse(localStorage.getItem("token"));

    // check if the token is expired, if yes trigger logOut
    if (isTokenExpires(token)) {
      // Just updating it to reload the page, since the token is no longer available
      // The user will redirected to the login page
      window.location.href = window.location.href;
      AuthService.logout();
    }

    config.headers = {
      Authorization: token,
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

Axios.interceptors.response.use(
  (response) => {
    const method = response.config.method?.toLowerCase();
    const url = response.config.url?.toLowerCase();

    // update last change date API endpoints that should trigger last update
    const updateEndpoints = [
      "/api/careplanwizard/savecareplanclientcomment",
      "/api/careplanwizard/addcarecircleuser",
      "/api/careplanwizard/addcarecirclehpc",
      "/api/careplanwizard/bulkassociatecareplanusers",
      "/api/careplanwizard/removecareplanuserassociation",
      "/api/careplanwizard/savecareplanddboard",
      "/api/careplanwizard/copycalltreeuser",
      "/api/careplanwizarddetail/updatepersonaldetails",
      "/api/careplanwizarddetail/addemergencycontact",
      "/api/careplanwizarddetail/updatecareplaninformation",
      "/api/careplanactions/addfuturecalendartemplate",
      "/api/careplanactions/deletecalendaritem",
      "/api/careplanactions/deletecalendartemplate",
      "/api/careplanactions/deletefuturecalendartemplate",
      "/api/careplanactions/deletegroupusercalendar",
      "/api/careplanactions/savecalendareffectivedate",
      "/api/careplanactions/savecalendartemplate",
      "/api/careplanactions/updatecalendartemplate",
      "/api/careplanactions/updatecalendaritem",
    ];

    const shouldUpdate =
      store.getState()?.wizard?.assignedClientProfile?.profileInfo &&
      ["put", "patch", "post", "delete"].includes(method) &&
      updateEndpoints.some((endpoint) => url?.includes(endpoint));

    if (shouldUpdate) {
      const user = store.getState()?.auth?.user?.user?.nameFull;
      store.dispatch({
        type: "UPDATE_LAST_CHANGE",
        payload: { date: new Date(), user },
      });
    }

    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default Axios;
